<template>
  <div class="d-flex justify-content-center mb-2" :class="{'align-items-start': siteBookingSettingServiceSelectEnabled, 'align-items-center': !siteBookingSettingServiceSelectEnabled}">
    <div class="mr-2">
      <pet-profile-image v-if="siteBookingSettingDisplayPetProfileImage" :pet="pet"/>
      <img v-else class="pet-photo" src="../../assets/Images/DogProfile_Blue_300.svg" width="100" alt="DefaultPetImage"/>
    </div>
    <div class="d-flex flex-column align-items-start w-100">
      <div class="summary-pet-name text-left">{{petName}} - {{breedName}}</div>
      <div v-if="siteBookingSettingDisplayResourceNameInSummary && resourceName" class="small">with {{ resourceName }}</div>
      <product-item v-for="item in serviceItems" :key="item.id" :product="item"/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { BreedCacheMixin } from '@/mixins/Booking/BreedCacheMixin'
import { SiteBookingSettingMixin } from '@/mixins/Booking/SiteBookingSettingMixin'
import { ResourceCacheMixin } from '@/mixins/Booking/ResourceCacheMixin'
import SummaryProductItem from '../Booking/SummaryProductItem.vue'
import PetProfileImage from '../Booking/PetProfileImage.vue'

export default {
  name: 'SummaryItem',
  mixins: [BreedCacheMixin, SiteBookingSettingMixin, ResourceCacheMixin],
  props: {
    pet: Object
  },
  computed: {
    ...mapState('BookingUpload', ['participants']),
    petName () {
      return this.pet?.name || ''
    },
    breedId () {
      return this.pet?.breedId || ''
    },
    serviceItems () {
      return this.pet?.serviceItems || []
    },
    resourceName () {
      const participant = this.participants.find(p => p.id === this.pet?.id)
      if (!participant) return ''
      const resource = this.unhiddenResources.find(r => r.id === participant.resourceId)
      return resource?.name || ''
    }
  },
  components: {
    'product-item': SummaryProductItem,
    'pet-profile-image': PetProfileImage
  }
}
</script>
